import { observer } from 'mobx-react-lite';

import classes from './GameOverlay.module.css';
import clsx from 'clsx';

const GameOverlay = ({forDial = false}) => {


  return (
    //<div className={classes.GameOverlay} />
    <div className={clsx(classes.GameOverlay, forDial && classes.mode_dial)} />
  );
};
    
export default observer(GameOverlay);